module.exports = __webpack_public_path__ + "static/media/worklocation.80e5af8f.png";